import {Route, Routes} from "react-router-dom";
import {RecoilRoot} from "recoil";
import Ancillaries from "./pages/Ancillaries/Ancillaries";
import AncillaryContainer from "./pages/Ancillary/AncillaryContainer";
import AncillaryExceptionContainer from "./pages/AncillaryException/AncillaryExceptionContainer";
import AncillaryExceptions from "./pages/AncillaryExceptions/AncillaryExceptions";
import ExceptionList from "./pages/ExceptionList/ExceptionList";
import ExceptionListAncillaryException from "./pages/ExceptionListAncillaryException/ExceptionListAncillaryException";
import ExcessGroup from "./pages/ExcessGroup/ExcessGroup";
import LocationGroup from "./pages/LocationGroup/LocationGroup";
import LocationGroupLocation from "./pages/LocationGroupLocation/LocationGroupLocation";
import ProductCodeLocationGroup from "./pages/ProductCodeLocationGroup/ProductCodeLocationGroup";
import RateContainer from "./pages/Rate/RateContainer";
import RateProductCodeLocationGroupForm
    from "./pages/RatePlan/RateProductCodeLocationGroupForm/RateProductCodeLocationGroupForm";
import RateProductCodeLocationGroupList
    from "./pages/RatePlan/RateProductCodeLocationGroupList/RateProductCodeLocationGroupList";
import Rates from "./pages/Rates/Rates";
import RentalPeriods from "./pages/RentalPeriod/RentalPeriods";
import ExcessProductCodeLocationGroupForm
    from "./pages/ExcessGroupPlan/ExcessProductCodeLocationGroupForm/ExcessProductCodeLocationGroupForm";
import ExcessProductCodeLocationGroupList
    from "./pages/ExcessGroupPlan/ExcessProductCodeLocationGroupList/ExcessProductCodeLocationGroupList";
import ExceptionProductCodeLocationGroupList
    from "./pages/ExceptionListPlan/ExceptionProductCodeLocationGroupList/ExceptionProductCodeLocationGroupList";
import ExceptionProductCodeLocationGroupForm
    from "./pages/ExceptionListPlan/ExceptionProductCodeLocationGroupForm/ExceptionProductCodeLocationGroupForm";
import OWLocationGroupLocation from "./pages/OWLocationGroupLocation/OWLocationGroupLocation";
import AlertTable from "./pages/Alert/Table/AlertTable";
import OWAncillaries from "./pages/OWAncillaries/OWAncillaries";
import OWAncillaryContainer from "./pages/OWAncillary/OWAncillaryContainer";
import OWAncillaryExceptions from "./pages/OWAncillaryExceptions/OWAncillaryExceptions";
import OWAncillaryExceptionContainer from "./pages/OWAncillaryException/OWAncillaryExceptionContainer";
import Report from "./pages/Report/Report";
import Peaks from "./pages/Peaks/Peaks";
import UpsellingRate from "./pages/UpsellingRate/UpsellingRate";
import GreenDiscountTable from "./pages/GreenDiscount/Table/GreenDiscountTable";
import ExportPricing from "./pages/Export/ExportPricing";
import ProductPlan from "./pages/ProductPlan/ProductPlan";
import AcrissOrder from "./pages/AcrissOrder/AcrissOrder";
import LocationDiscount from "./pages/LocationDiscount/LocationDiscount";
import DeskDiscountGovernance from "./pages/DeskDiscountGovernance/DeskDiscountGovernance";
import VehiclesAcrissOrder from "./pages/VehiclesAcrissOrder/VehiclesAcrissOrder";
import VehiclesLeadModel from "./pages/VehiclesLeadModel/VehiclesLeadModel";

const PricingMain = () => {
    return (
        <Routes>
            <Route path="/location-group/list" element={
                <RecoilRoot key="pricing.location-group">
                    <LocationGroup readOnly={false}/>
                </RecoilRoot>
            }/>
            <Route path="/location-group/location-group-location" element={
                <RecoilRoot key="pricing.location-group-location">
                    <LocationGroupLocation/>
                </RecoilRoot>
            }/>
            <Route path="/rental-period" element={
                <RecoilRoot key="pricing.rental-period">
                    <RentalPeriods/>
                </RecoilRoot>
            }/>
            <Route path="/rate/base-rates" element={
                <RecoilRoot key="pricing.rates">
                    <Rates/>
                </RecoilRoot>
            }/>
            <Route path="/rate/base-rates/create/new" element={
                <RecoilRoot key="pricing.rate-new">
                    <RateContainer/>
                </RecoilRoot>
            }/>
            <Route path="/rate/base-rates/create/:id" element={
                <RecoilRoot key="pricing.rate">
                    <RateContainer/>
                </RecoilRoot>
            }/>
            <Route path="/ancillary/ancillary" element={
                <RecoilRoot key="pricing.ancillaries">
                    <Ancillaries/>
                </RecoilRoot>
            }/>
            <Route path="/ancillary/ancillary/create/new" element={
                <RecoilRoot key="pricing.ancillary-new">
                    <AncillaryContainer/>
                </RecoilRoot>
            }/>
            <Route path="/ancillary/ancillary/create/:id" element={
                <RecoilRoot key="pricing.ancillary">
                    <AncillaryContainer/>
                </RecoilRoot>
            }/>
            <Route path="/ancillary/ancillary-exception" element={
                <RecoilRoot key="pricing.ancillary-exception">
                    <AncillaryExceptions/>
                </RecoilRoot>
            }/>
            <Route path="/ancillary/ancillary-exception/create/new" element={
                <RecoilRoot key="pricing.ancillary-exception-new">
                    <AncillaryExceptionContainer/>
                </RecoilRoot>
            }/>
            <Route path="/ancillary/ancillary-exception/create/:id" element={
                <RecoilRoot key="pricing.ancillary-exception">
                    <AncillaryExceptionContainer/>
                </RecoilRoot>
            }/>
            <Route path="/ancillary/exception-list" element={
                <RecoilRoot key="pricing.exception-list">
                    <ExceptionList/>
                </RecoilRoot>
            }/>
            <Route path="/ancillary/exception-list-ancillary-exception" element={
                <RecoilRoot key="pricing.exception-list-ancillary">
                    <ExceptionListAncillaryException/>
                </RecoilRoot>
            }/>
            <Route path="/ow/ow-location-group-location" element={
                <RecoilRoot key="pricing.ow-location-group-location">
                    <OWLocationGroupLocation/>
                </RecoilRoot>
            }/>
            <Route path="/ow/ow-ancillary" element={
                <RecoilRoot key="pricing.ow-ancillaries">
                    <OWAncillaries/>
                </RecoilRoot>
            }/>
            <Route path="/ow/ow-ancillary/create/new" element={
                <RecoilRoot key="pricing.ow-ancillary">
                    <OWAncillaryContainer/>
                </RecoilRoot>
            }/>
            <Route path="/ow/ow-ancillary/create/:id" element={
                <RecoilRoot key="pricing.ow-ancillary">
                    <OWAncillaryContainer/>
                </RecoilRoot>
            }/>
            <Route path="/ow/ow-ancillary-exception" element={
                <RecoilRoot key="pricing.ow-ancillary-exception">
                    <OWAncillaryExceptions/>
                </RecoilRoot>
            }/>
            <Route path="/ow/ow-ancillary-exception/create/new" element={
                <RecoilRoot key="pricing.ow-ancillary-exception">
                    <OWAncillaryExceptionContainer/>
                </RecoilRoot>
            }/>
            <Route path="/ow/ow-ancillary-exception/create/:id" element={
                <RecoilRoot key="pricing.ow-ancillary-exception">
                    <OWAncillaryExceptionContainer/>
                </RecoilRoot>
            }/>
            <Route path="/excess-group" element={
                <RecoilRoot key="pricing.excess-group">
                    <ExcessGroup/>
                </RecoilRoot>
            }/>
            <Route path="/product-code/location-group" element={
                <RecoilRoot key="pricing.product-code-location-group">
                    <ProductCodeLocationGroup/>
                </RecoilRoot>
            }/>
            <Route path="/product-code/product-plan" element={
                <RecoilRoot key="pricing.product-code-product-plan">
                    <ProductPlan/>
                </RecoilRoot>
            }/>
            <Route path="/product-code/location-group-rate/create" element={
                <RecoilRoot key="pricing.rate-plan-create">
                    <RateProductCodeLocationGroupForm readOnly={false}/>
                </RecoilRoot>
            }/>
            <Route path="/product-code/location-group-rate/list" element={
                <RecoilRoot key="pricing.exception-list-ancillary">
                    <RateProductCodeLocationGroupList/>
                </RecoilRoot>
            }/>
            <Route path="/product-code/location-group-excess-group/create" element={
                <RecoilRoot key="pricing.excess-plan-create">
                    <ExcessProductCodeLocationGroupForm readOnly={false}/>
                </RecoilRoot>
            }/>
            <Route path="/product-code/location-group-excess-group/list" element={
                <RecoilRoot key="pricing.excess-plan-list">
                    <ExcessProductCodeLocationGroupList/>
                </RecoilRoot>
            }/>
            <Route path="/product-code/location-group-exception-list/create" element={
                <RecoilRoot key="pricing.exception-plan-create">
                    <ExceptionProductCodeLocationGroupForm readOnly={false}/>
                </RecoilRoot>
            }/>
            <Route path="/product-code/location-group-exception-list/list" element={
                <RecoilRoot key="pricing.exception-plan-list">
                    <ExceptionProductCodeLocationGroupList/>
                </RecoilRoot>
            }/>
            <Route path="/upselling-rate" element={
                <RecoilRoot key="pricing.upselling-rate">
                    <UpsellingRate/>
                </RecoilRoot>
            }/>
            <Route path="/peak" element={
                <RecoilRoot key="pricing.peaks">
                    <Peaks/>
                </RecoilRoot>
            }/>
            <Route path="/alert" element={
                <RecoilRoot key="pricing.alert">
                    <AlertTable/>
                </RecoilRoot>
            }/>
            <Route path="/report" element={
                <RecoilRoot key="pricing.report">
                    <Report/>
                </RecoilRoot>
            }/>
            <Route path="/green-discount" element={
                <RecoilRoot key="pricing.green-discount">
                    <GreenDiscountTable/>
                </RecoilRoot>
            }/>
            <Route path="/export" element={
                <RecoilRoot key="pricing.export">
                    <ExportPricing/>
                </RecoilRoot>
            }/>
            <Route path="/acriss-order" element={
                <RecoilRoot key="pricing.acriss-order">
                    <AcrissOrder/>
                </RecoilRoot>
            }/>
            <Route path="/location-discount" element={
                <RecoilRoot key="pricing.location-discount">
                    <LocationDiscount/>
                </RecoilRoot>
            }/>
            <Route path="/desk-discount-governance" element={
                <RecoilRoot key="pricing.desk-discount-governance">
                    <DeskDiscountGovernance/>
                </RecoilRoot>
            }/>
            {/*<Route path="/vehicles/acriss-order" element={
                <RecoilRoot key="pricing.vehicles">
                    <VehiclesAcrissOrder/>
                </RecoilRoot>
            }/>*/}
            <Route path="/lead-model" element={
                <RecoilRoot key="pricing.vehicles">
                    <VehiclesLeadModel/>
                </RecoilRoot>
            }/>
        </Routes>
    );
};

export default PricingMain;